import React, {useEffect} from "react";
import {Excalidraw, serializeAsJSON} from "@excalidraw/excalidraw";

const ExcalidrawComponent = ({id, initialData}) => {
  const [excalidrawAPI, setExcalidrawAPI] = React.useState(null);
  const checkIsString = (key, val) => {
    if (typeof val === 'string') {
      try {
        return JSON.parse(val);
      } catch (e) {
      }
    }
    return val;
  }

  const saveToBackend = () => {
    if (excalidrawAPI) {
      fetch(`/diagrams/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          content: serializeAsJSON(
            excalidrawAPI.getSceneElements(),
            excalidrawAPI.getAppState(),
            excalidrawAPI.getFiles(),
            "database"
          )
        }, checkIsString)
      }).then((response) => {
        if (response.ok) {
          console.log("Saved to backend");
        } else {
          console.error("Failed to save to backend");
        }
      })
    }
  }

  useEffect(() => {
    const interval = setInterval(saveToBackend, 20000); // 20000 milliseconds = 20 seconds

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, [excalidrawAPI]);

  const UIOptions = {
    canvasActions: {
      export: {
        saveFileToDisk: false,
        renderCustomUI: (props) => {
          return (
            <button
              className="excalidraw-button excalidraw-button-export"
              onClick={saveToBackend}
            >
              Salvar no nosso backend
            </button>
          );
        },
      }
    },
  };
  return (

    <div style={{width: "100vw", height: "100vh"}}>
      <Excalidraw
        excalidrawAPI={(api) => setExcalidrawAPI(api)}
        initialData={initialData}
        UIOptions={UIOptions}/>
    </div>
  )

}

export default ExcalidrawComponent;